import { Skeleton } from "@mui/material";
import API from "@unisearch/helpers/api";
import dynamic from "next/dynamic";
import Link from "next/link";
import { Fragment, useEffect, useState } from "react";
const baseUrl = process.env.NEXT_PUBLIC_URL;

import { LeadForm } from "@modules/lead/components";
import SocialSharingLinks from "@modules/study/common/social_sharing_links";
import Advertisement from "@unisearch/common/advertisement";
import { addGoogleAdScript, htmlParse } from "@unisearch/helpers";
import BlogBoxGrid from "../components/blog_grid_box";
import styles from "./blog_single_body.module.scss";
const UniComment = dynamic(() => import("@modules/study/common/comment"), {
  ssr: false,
});

export const BlogSingleBody = ({ pageData }) => {
  const catPrimary = pageData?.parimaryCategory?.title;
  const [formData, setFormData] = useState();
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);

  const fetchData = async () => {
    const res = await API.get(`public/lead-contact-form/pages/popup`);
    if (res && !res.error) {
      setFormData(res.data);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchDataBlogs = async () => {
      try {
        setLoading(true);
        const endpoint = `/public/blog-page/category/${pageData?.parimaryCategory?.slug}?limit=10`;
        const resp = await API.get(endpoint);
        setLoading(false);
        const { results } = resp?.data;
        setPosts(results);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchDataBlogs();
  }, []);
  const style = posts?.length === 0 ? { marginTop: "0" } : {};

  // addvertisement functionality
  const ShowAddvertisement = () => {
    if (
      catPrimary === "Study in UK" ||
      pageData?.categories?.find((item) => item.title === "Study in UK") ||
      pageData?.categories?.find((item) => item.title === "Study in the UK")
    ) {
      return (
        <Advertisement
          width={300}
          height={250}
          src="/ad/study-in-uk-mobile.webp"
          url="https://myunisearch.com/lead/study-in-the-uk"
        />
      );
    } else if (
      catPrimary === "Study in USA" ||
      pageData?.categories?.find((item) => item.title === "Study in USA") ||
      pageData?.categories?.find((item) => item.title === "Study in the USA")
    ) {
      return (
        <Advertisement
          width={300}
          height={250}
          src="/ad/study-in-usa-mobile.webp"
          url="https://myunisearch.com/lead/apply-for-scholarships-at-the-university-of-arizona"
        />
      );
    } else if (
      catPrimary === "Study in Australia" ||
      pageData?.categories?.find((item) => item.title === "Study in Australia")
    ) {
      return (
        <Advertisement
          width={300}
          height={250}
          src="/ad/study-in-au-mobile.webp"
          url="https://myunisearch.com/lead/apply-for-scholarships-at-the-victoria-university"
        />
      );
    } else if (
      catPrimary === "Study in Canada" ||
      pageData?.categories?.find((item) => item.title === "Study in Canada")
    ) {
      return (
        <Advertisement
          width={300}
          height={250}
          src="/ad/study-in-canada-mobile.webp"
          url="https://myunisearch.com/lead/study-in-canada"
        />
      );
    } else if (
      catPrimary === "Study in Ireland" ||
      pageData?.categories?.find((item) => item.title === "Study in Ireland")
    ) {
      return (
        <Advertisement
          width={300}
          height={250}
          src="/ad/study-in-ireland-mobile.webp"
          url="#"
        />
      );
    } else if (
      catPrimary === "study in New Zealand" ||
      pageData?.categories?.find(
        (item) => item.title === "Study in New Zealand"
      )
    ) {
      return (
        <Advertisement
          width={300}
          height={250}
          src="/ad/study-in-new-zealand-mobile.webp"
          url="#"
        />
      );
    } else {
      return (
        <Advertisement
          width={300}
          height={250}
          src="/ad/study-in-au-mobile.webp"
          url="https://myunisearch.com/lead/apply-for-scholarships-at-the-victoria-university"
        />
      );
    }
  };

  const LeadFormComponent = ({ className }) => {
    return (
      <>
        {formData && (
          <div
            className={`${styles.lead_form_wrapper} ${
              className?.root ? className?.root : ""
            }`}
            style={style}
          >
            <div className={styles.lead_form_heading_wrapper}>
              <h3
                className={`${styles.lead_heading} ${
                  className?.heading ? className?.heading : ""
                }`}
              >
                Want to study abroad? Sign up with{" "}
                <span className={"color-orange"}>UniSearch!</span>
              </h3>
              <p
                className={`${styles.lead_sub_heading} ${
                  className?.subheading ? className?.subheading : ""
                }`}
              >
                Jumpstart your study abroad dreams with UniSearch
              </p>
            </div>
            <LeadForm
              showTitle={false}
              showSubTitle={false}
              pageData={formData}
              buttonTitle="Submit"
              pageSlug={formData?.slug}
              columnSizeFull={true}
            />
          </div>
        )}
      </>
    );
  };

  let contentFirst;
  let contentLast;
  const isShortCodeFormExist =
    pageData &&
    pageData?.content &&
    pageData?.content?.includes("[shortcode_form]");

  if (isShortCodeFormExist) {
    const text = pageData?.content.split("[shortcode_form]");
    contentFirst = text[0];
    contentLast = text[1];
  }

  return (
    <section className={styles.section_blog_body}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.blog_body}>
            <SocialSharingLinks
              className={styles.blog_links_wrapper}
              url={`${baseUrl}/blog/${pageData?.slug}`}
              title={pageData?.title}
            />
            <div className={styles.body}>
              <div className="flex justify-center mb-5 w-full">
                <script
                  async
                  src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972"
                  crossorigin="anonymous"
                ></script>
                <ins
                  className="adsbygoogle"
                  style={{
                    display: "inline-block",
                    width: "336px",
                    height: "280px",
                  }}
                  data-ad-client="ca-pub-1690314786863972"
                  data-ad-slot="7944985031"
                ></ins>
                <script>
                  {`(adsbygoogle = window.adsbygoogle || []).push({});`}
                </script>
              </div>

              <div className="from_texteditor_wrapper">
                {isShortCodeFormExist ? (
                  <>
                    {
                      <>
                        {addGoogleAdScript(
                          contentFirst,
                          `<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972"
                            crossorigin="anonymous"></script>
                            <ins class="adsbygoogle"
                                style="display:inline-block;width:300px;height:250px"
                                data-ad-client="ca-pub-1690314786863972"
                                data-ad-slot="3075801734"></ins>
                            <script>
                                (adsbygoogle = window.adsbygoogle || []).push({});
                            </script>
                         `,
                          40
                        )}
                        <LeadFormComponent
                          className={{
                            root: "!static !mb-8",
                            heading:
                              "text-center !text-3xl max-w-[90%] mx-auto",
                            subheading: "text-center !text-base",
                          }}
                        />
                        {htmlParse(contentLast)}
                      </>
                    }
                  </>
                ) : (
                  <>
                    {addGoogleAdScript(
                      pageData?.content,
                      `<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972"
                        crossorigin="anonymous"></script>
                        <ins class="adsbygoogle"
                            style="display:inline-block;width:300px;height:250px"
                            data-ad-client="ca-pub-1690314786863972"
                            data-ad-slot="3075801734"></ins>
                        <script>
                            (adsbygoogle = window.adsbygoogle || []).push({});
                        </script>
                    `,
                      90
                    )}
                  </>
                )}
              </div>

              {pageData && pageData?.tags?.length > 0 && (
                <div className={styles.tags_wrapper}>
                  <ul>
                    {pageData?.tags?.map((tag, i) => {
                      return (
                        <li key={`blogtag${i}`}>
                          <Link legacyBehavior href={`/blog/tag/${tag?.slug}`}>
                            <a>{tag?.title}</a>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}

              <div className="mb-6 w-full flex justify-center">
                <script
                  async
                  src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972"
                  crossorigin="anonymous"
                ></script>
                <ins
                  className="adsbygoogle"
                  style={{ display: "block" }}
                  data-ad-format="autorelaxed"
                  data-ad-client="ca-pub-1690314786863972"
                  data-ad-slot="5945244324"
                ></ins>
                <script>
                  {`(adsbygoogle = window.adsbygoogle || []).push({});`}
                </script>
              </div>

              <UniComment commentType={"blog"} referenceId={pageData?.id} />
            </div>

            <div className={styles.sidebar}>
              {/* ad */}
              <ShowAddvertisement />

              <>
                {loading ? (
                  <>
                    {new Array(5).fill(1).map((_, i) => {
                      return (
                        <div key={i}>
                          <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={150}
                          />
                          <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={20}
                            sx={{ margin: "15px 0px 0px 0px" }}
                          />
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <div className={styles.blog_grid_wrapper}>
                    {posts?.length > 0 &&
                      posts
                        ?.filter((post, i) => pageData?.id !== post?.id)
                        .map((post, i) => {
                          return (
                            <Fragment key={i}>
                              <BlogBoxGrid
                                blogTitle={post?.title}
                                blogLink={`/blog/${post?.slug}`}
                                categoryTitle={post?.category?.categoryName}
                                calegoryLink={`/blog/category/${post?.category?.slug}`}
                                featureImage={
                                  post?.posterImage?.src ||
                                  post?.featureImage?.src
                                }
                                videoType={post?.videoType}
                              />
                              {/* ad */}
                              <>{i == 4 && <ShowAddvertisement />}</>
                            </Fragment>
                          );
                        })}
                  </div>
                )}
              </>

              {/* Lead form */}
              {<LeadFormComponent />}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSingleBody;
